import merge from "lodash/merge";

import { svg } from "config/svgStyles";

export const appLayout =
  ({ isDisplayingModals }) =>
  ({ isMobile }) => ({
    overflow: isDisplayingModals ? "hidden" : "auto",
    backgroundColor: "background",
    color: "text",
    fontFamily: "body",
    height: "100%",
    position: "relative",
    width: "100%",

    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: isMobile ? "flex-start" : "center",

    "&:before": {
      content: `""`,
      height: "160px",
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      pointerEvents: "none",
      zIndex: "10",
      backgroundImage: (theme) =>
        `linear-gradient(180deg, ${theme.colors.coolGrey9} 0%, rgba(221, 228, 231, 0) 100%)`,
    },
  });

export const appHeader = ({ isMobile }) =>
  merge(
    {
      borderBottom: isMobile ? "solid 1px" : "none",
      borderColor: "grey9",
      margin: isMobile ? "20px" : 0,
      pb: isMobile ? "20px" : 0,
      position: "relative",
      zIndex: 20,
    },

    !isMobile && {
      position: "absolute",
      top: "40px",
      left: "40px",
    }
  );

export const closeApp = ({ isMobile }) => ({
  position: "absolute",
  top: isMobile ? "22px" : "42px",
  right: isMobile ? "22px" : "42px",
  zIndex: 500,
  display: "flex",
  gap: "15px",
  alignItems: "center",
});

export const closeAppText = () => ({
  fontSize: "20px",
  fontWeight: 300,
  lineHeight: "20px",
  letterSpacing: "0.05em",
  textAlign: "left",
  textTransform: "uppercase",
  color: "#7B8285",
});

export const closeButton = () => ({
  width: "21px",
  height: "21px",
  ...svg("black"),
});

export const bottomShadow = {
  height: "0px",
  background: "coolGrey9",
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  pointerEvents: "none",
  zIndex: "10",

  "&:before": {
    content: `""`,
    height: "160px",
    position: "absolute",
    left: 0,
    right: 0,
    top: "-160px",
    pointerEvents: "none",
    zIndex: "10",

    backgroundImage: (theme) =>
      `linear-gradient(0deg, ${theme.colors.coolGrey9} 0%, rgba(221, 228, 231, 0) 100%)`,
  },
};
